import React from 'react';
import {Col, Row} from 'antd';
import ENDPOINTS from '../../../../constants/endpoints';
import useDefaultRequest from '../../../../hooks/useDefaultRequest';
import ReportChartCard from '../../../../components/admin/reports/ReportChartCard';
import TimeSeriesLineChart from '../../../../components/admin/reports/charts/TimeSeriesLineChart';
import {dateFormat, moneyMask} from '../../../../utils/utils';

export default function GrowthChart({dateFrom, dateTo}) {
    const {data, isLoading} = useDefaultRequest({
        url: ENDPOINTS.REPORTS_ECOMMERCE_GROWTH,
        params: {date_from: dateFrom, date_to: dateTo},
        dataDefault: {},
    });
    const series = data?.series || [];

    return (
        <Row gutter={[16, 0]}>
            <Col xs={24} lg={12}>
                <ReportChartCard title="Evolução de Pedidos" loading={isLoading} isEmpty={!series.length}>
                    <TimeSeriesLineChart
                        data={series}
                        dataKey="orders"
                        type="bar"
                        periodFormatter={(v) => dateFormat(v, 'MMM/YY')}
                        tooltipFields={[
                            {key: 'orders', label: 'Pedidos'},
                            {key: 'pct_change', label: 'Variação (%)', formatter: (v) => (v == null ? '-' : `${v}%`)},
                        ]}
                    />
                </ReportChartCard>
            </Col>
            <Col xs={24} lg={12}>
                <ReportChartCard title="Evolução de Receita" loading={isLoading} isEmpty={!series.length}>
                    <TimeSeriesLineChart
                        data={series}
                        dataKey="revenue"
                        periodFormatter={(v) => dateFormat(v, 'MMM/YY')}
                        valueFormatter={(v) => `R$ ${moneyMask(v)}`}
                        tooltipFields={[
                            {key: 'revenue', label: 'Receita', formatter: (v) => `R$ ${moneyMask(v)}`},
                            {key: 'pct_change', label: 'Variação (%)', formatter: (v) => (v == null ? '-' : `${v}%`)},
                        ]}
                    />
                </ReportChartCard>
            </Col>
        </Row>
    );
}
